export default "__VITE_ASSET__BTtzT8xj__"